import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "./client";

// Admin-only: release a HOLD order to production.
export function useReleaseOrder() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (orderId: string) =>
      api(`/api/v1/orders/${orderId}/release`, { method: "POST" }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["admin", "orders"] });
      qc.invalidateQueries({ queryKey: ["admin", "audit"] });
    },
  });
}

// Brand-profile patch (server enforces brand-lock for non-admins).
type BrandPatch = {
  name?: string;
  accent?: string;
  secondary?: string;
  tagline?: string;
  rhText?: string | null;
  activationUrl?: string | null;
  logoText?: string | null;
};
export function useUpdateBrandProfile(brandId: string | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (patch: BrandPatch) => {
      if (!brandId) throw new Error("No brand id");
      return api(`/api/v1/brand-profiles/${brandId}`, {
        method: "PATCH",
        body: patch,
      });
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["brand-profiles"] });
      qc.invalidateQueries({ queryKey: ["my-brand-profile"] });
      qc.invalidateQueries({ queryKey: ["admin", "clients"] });
      qc.invalidateQueries({ queryKey: ["admin", "audit"] });
    },
  });
}
